<rt-dropdown
  #dropdownComponent
  [width]="DropdownWidth.LargeXX"
  class="new-evaluation"
  (click)="$event.preventDefault()"
>
  <ng-container
    *ngTemplateOutlet="header; context: { text: 'app.interview.dropdown_header' | translate }"
  />

  <div layout layout-vertical padding>
    <rt-new-item-button
      icon="border-color"
      [heading]="'app.interview.add_new.add_evaluation.heading' | translate"
      [subheading]="'app.interview.add_new.add_evaluation.subheading' | translate"
      [targetFor]="evaluationFormsTpl"
      margin-bottom
    />

    <rt-new-item-button
      icon="person-add"
      [heading]="'app.interview.add_new.request_evaluation.heading' | translate"
      [subheading]="'app.interview.add_new.request_evaluation.subheading' | translate"
      [targetFor]="evaluationRequestTpl"
    />
  </div>

  <ng-template #evaluationRequestTpl>
    <ng-container
      *ngTemplateOutlet="
        header;
        context: {
          text: 'app.interview.dropdown_header_team' | translate,
          backButton: !this.forceNestedDropdown(),
        }
      "
    />
    <rt-request-evaluation-tab
      [admins]="admins()"
      [offers]="offers()"
      [schedule]="schedule()"
      [allTemplates]="templates()"
      [hasOffers]="state.hasOffers"
      [allowedUsers]="allowedUsers()!"
      [canManageInterviewTemplates]="canManageInterviewTemplates"
      [candidate]="candidate()"
      [candidateId]="candidateId()"
      [offerId]="offerId()"
      [translations]="translations"
      (close)="closeDropdown()"
      (submit)="submitInterviewRequest($any($event))"
    />
  </ng-template>

  <ng-template #evaluationFormsTpl>
    <ng-container
      *ngTemplateOutlet="
        header;
        context: {
          text: 'app.interview.dropdown_header_me' | translate,
          backButton: !this.forceNestedDropdown(),
        }
      "
    />
    <rt-evaluation-forms-tab
      [offers]="offers()"
      [schedule]="schedule()"
      [allTemplates]="templates()"
      [hasOffers]="state.hasOffers"
      [candidate]="candidate()"
      [candidateId]="candidateId()"
      [fromHiddenEvaluations]="fromHiddenEvaluations()"
      [canManageInterviewTemplates]="canManageInterviewTemplates"
      [translations]="translations"
      (close)="closeDropdown()"
      (submit)="submitNewInterview($any($event))"
    />
  </ng-template>

  <ng-template #header let-text="text" let-backButton="backButton">
    <rt-dropdown-header>
      @if (backButton) {
        <rt-icon-button
          (click)="dropdownComponent.prevTemplate()"
          iconName="arrow-back"
          size="small"
          variant="plain"
          shape="square"
          prefix
          [rtTooltip]="'app.interview.back' | translate"
        />
      }
      {{ text }}
      @if (canManageInterviewTemplates) {
        <rt-icon-button
          [routerLink]="['/settings/evaluation_forms']"
          variant="plain"
          size="small"
          shape="square"
          iconName="settings"
          suffix
          [rtTooltip]="'app.interview.manage_forms' | translate"
        />
      }
    </rt-dropdown-header>
  </ng-template>
</rt-dropdown>
